import React, { useContext } from 'react';
import LOGO from '../../Assets/logo2.png';
import HeaderRight from './HeaderRight';
import { useAppContext } from '../../context/AppContext';

const Header = ({ onMobileMenuToggle }) => {
  const {authState} = useAppContext()

  console.log(authState)
  return (
    <header className="fixed top-0 left-0 right-0 h-16 bg-gray-800 text-white flex justify-between items-center px-4 z-40 " style={{borderBottom:'1px solid white'}}>
      {/* Logo */}
      <div className="flex items-center flex-shrink-0">
        <img src={LOGO} alt="Logo" className="h-10 w-10 mr-2" />
        Lightning Presort
      </div>
<div>{authState.user.name}</div>
      {/* Right side icons & mobile hamburger */}
      <HeaderRight onMobileMenuToggle={onMobileMenuToggle} />
    </header>
  );
};

export default Header;
